import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface RetryAutoSaveButtonProps {
  onRetry: () => void;
}

export const RetryAutoSaveButton = ({ onRetry }: RetryAutoSaveButtonProps) => {
  const { language } = useLanguage();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleAutoSaveFailed = () => {
      setShowButton(true);
    };

    window.addEventListener('autosave-failed', handleAutoSaveFailed);

    return () => {
      window.removeEventListener('autosave-failed', handleAutoSaveFailed);
    };
  }, []);

  const handleRetry = () => {
    setShowButton(false);
    onRetry();
  };

  if (!showButton) return null;

  return (
    <Button
      onClick={handleRetry}
      variant="outline"
      size="sm"
      className="flex items-center gap-2 border-destructive text-destructive hover:bg-destructive/10"
    >
      <RefreshCw className="h-4 w-4" />
      {language === 'ar' ? 'إعادة المحاولة' : 'Retry Save'}
    </Button>
  );
};
